import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const IMPACT_DEAL_PAGE_PATH = '/quince-offers'
const IMPACT_DEAL_PAGE_PLACING = 'Deal_Page'

export const getPlacingForImpactTracker = (defaultLocation: string) => {
  if (!isBrowser()) return defaultLocation
  const currentPagePath = window.location.pathname
  if (currentPagePath === IMPACT_DEAL_PAGE_PATH) return IMPACT_DEAL_PAGE_PLACING
  return defaultLocation
}
